<template>
  <section class="features">
    <div class="container"
         style="margin-top: 15px;background: #CCE7F8;padding: 5px;text-align: left;display: flex;align-items: center">
      <img src="https://www.mgadmob.com/mp/icon/ic_onlinejob.png" style="height: 35px">
      <span style="color: #6C6C6C;font-size: 14px;margin-left: 5px;margin-right: 5px">线上兼职发布专属通道</span>
      <a class="rightclick" @click="gotoOnlineJob">去发布></a>
    </div>
    <div class="container"
         style="background: white;padding: 15px;margin-top: 15px;display: flex;flex-direction: column;text-align: left">
      <div class="publishjob">发布职位</div>
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 5px;">
        <div class="divider"></div>
        <div class="subtitle">选择要招聘的岗位类型</div>
      </div>
      <CustomGridView :items="jobtypes" :selected-index="selectJobIndex" @itemClick="onGridItemClick"/>
      <div class="container"
           style="margin-top: 15px;padding: 5px;text-align: left;display: flex;align-items: center">
        <span class="notfindjob">没有找到想招的岗位？</span>
        <a class="rightclick" @click=" showMore()">{{ selectedMoreJob }}></a>
      </div>
      <div style="display: flex;flex-direction: row;align-items: center;margin-top: 20px;">
        <div class="divider"></div>
        <div class="subtitle">工作地址</div>
      </div>
      <div class="address">
        <Select v-model="selectCity" placeholder="请搜索或选择城市" filterable @on-change="handleChange">
          <Option v-for="item in allCity" :key="item" :value="item">
            {{ item }}
          </Option>
        </Select>
        <Select v-model="selectArea" placeholder="请搜索或选择区域" filterable style="margin-top: 15px" :disabled="selectCity == null || allArea.length == 0">
          <Option v-for="item in allArea" :key="item" :value="item">
            {{ item }}
          </Option>
        </Select>
        <Input v-model="address" placeholder="请输入具体地址" clearable :maxlength="120" style="margin-top: 15px">
        </Input>
      </div>
      <div class="bottom">
        <a class="bottombtn" style="margin-right: 10px;" @click="preClick()">上一步</a>
        <a class="bottombtn" style="margin-left: 10px" @click="nextClick()">下一步</a>
      </div>
    </div>
    <CenterDialog
      :visible.sync="showQrCode"
      type="image"
      width="350px"
      :image="imageQrcode"
      :showActions="false"
    />
    <liudropdownsingle :menuList="menuList" :dataObj="dataObj" @change="ropdownChange"
                       @close="isShowMoreJob = false" :visible="isShowMoreJob" style="position: absolute;width: 100%;">
    </liudropdownsingle>
  </section>
</template>

<script>
import CustomGridView from "@/views/toc/custom-grid-view-simple.vue";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";
import liudropdownsingle from "@/views/toc/SelectJobType/SelectJob.vue"
import api from "@/api";
import router from "@/router";

export default {
  name: 'PostJobStep1',
  components: {CenterDialog, CustomGridView, liudropdownsingle},
  created() {
    this.getAllCity()
    this.getAllJobTypes()
  },
  data() {
    return {
      showQrCode: false,
      imageQrcode: "https://www.mgadmob.com/mp/img/postImage.png",
      selectJobIndex: -1,
      selectedItem: null,
      allCity: [],
      allArea: [],
      address: null,
      selectCity: null,
      selectArea: null,
      selectedMoreJob: '查看更多',
      selectedMoreJobId: -1,
      isShowMoreJob: false,
      //菜单信息
      menuList: [{
        id: 1,
        name: '招聘岗位选择',
        isMultiple: false, //是否多选
        showType: 1, //下拉框类型(1、2、3、4)
        showName: ''
      }],
      dataObj: {
        //类型1数据结构
        itemList1: [{
          id: 1,
          name: '热门',
          childs: [{
            id: -1,
            name: '主播',
            chooseState: true //默认选中
          }, {
            id: -2,
            name: '客服'
          }, {
            id: -3,
            name: '文案编辑'
          }]
        }, {
          id: 2,
          name: '市场推广',
          childs: [{
            id: -1,
            name: '网店'
          }, {
            id: -2,
            name: '短视频'
          }, {
            id: -3,
            name: '电商'
          }]
        }]
      },
      jobtypes: [{
        id: 137,
        title: '餐厅服务员',
        textColor: '#333333',
        textColorSelected: '#33D0B2',
        borderColor: '#EAECEE',
        borderColorSelect: '#33D0B2',
      },
        {
          id: 151,
          title: '导购店员',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 124,
          title: '外卖骑手',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 97,
          title: '工厂普工',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 118,
          title: '保洁',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 117,
          title: '保安',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 304,
          title: '地推销售',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 138,
          title: '后厨',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 313,
          title: '分拣',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
        {
          id: 305,
          title: '电话销售',
          textColor: '#333333',
          textColorSelected: '#33D0B2',
          borderColor: '#EAECEE',
          borderColorSelect: '#33D0B2',
        },
      ]
    }
  },
  methods: {
    onGridItemClick(index) {
      this.selectJobIndex = index
      this.selectedItem = this.jobtypes[index]
      this.selectedMoreJob = '查看更多'
    },
    gotoOnlineJob() {
      this.showQrCode = true
    },
    showMore() {
      this.isShowMoreJob = !this.isShowMoreJob
      this.selectedItem = null
      this.selectJobIndex = -1
    },
    handleChange(value) {
      this.selectCity = value;
      this.getAllArea()
    },
    getAllCity() {
      api.statistics
        .getAllCity()
        .then(res => {
          if (res.code == 2000) {
            this.allCity = res.data
          } else {
            this.$Message.error(res.msg)
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getAllArea() {
      api.statistics
        .getAreaByCity(this.selectCity)
        .then(res => {
          if (res.code == 2000) {
            this.allArea = res.data
          } else {
            this.$Message.error(res.msg)
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getAllJobTypes() {
      api.statistics
        .getAllJobTypes()
        .then(res => {
          if (res.code == 2000) {
            //数组转为数组对象
            let result = []
            for (let key in res.data) {
              result.push({
                name: res.data[key].dictName,
                id: Number(key),
                childs: res.data[key].dicts
              })
            }
            this.dataObj.itemList1 = result
            for (let i = 0; i < res.data.length; i++) {
              let childs = []
              if (res.data[i].dicts != null) {
                for (var j = 0; j < res.data[i].dicts.length; j++) {
                  childs.push({
                    name: res.data[i].dicts[j].dictLabel,
                    id: res.data[i].dicts[j].id,
                  })
                }
              }
              this.dataObj.itemList1[i].childs = childs
            }
          } else {
            this.$Message.error(res.msg)
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    preClick() {
      // window.location.reload(true)
      this.$router.back()
    },
    nextClick() {
      if (this.selectedItem == null && (this.selectedMoreJob == '' || this.selectedMoreJob == null || this.selectedMoreJob == '查看更多')) {
        this.$Message.info('请选择发布岗位类型')
        return
      }

      if (this.selectCity === null) {
        this.$Message.info('请选择城市')
        return
      }
      if (this.selectArea === null) {
        this.$Message.info('请选择区域')
        return
      }
      if (this.address === null || this.address.trimEnd() === '') {
        this.$Message.info('请输入详细地址')
        return
      }
      let selectedJob = ""
      let selectedJobId = null
      if (this.selectedItem != null) {
        selectedJob = this.selectedItem.title
        selectedJobId = this.selectedItem.id
      } else {
        selectedJob = this.selectedMoreJob
        selectedJobId = this.selectedMoreJobId
      }
      this.$router.replace({
        name: 'postjobstep2',
        params: {
          citySelect: this.selectCity,
          selectedJob: selectedJob,
          address: this.address,
          selectedJobId: selectedJobId,
          areaSelect: this.selectArea,
        }
      });
    },
    ropdownChange(e) {
      if (e.chooseMenu.showName !== '' && e.chooseMenu.showName != null) {
        this.selectedMoreJob = e.chooseMenu.showName
        this.selectedMoreJobId = e.chooseInfo.itemList1[0].childs[0].id
      }
    },
  }
}
</script>

<style scoped>
.features {
  background: #F6F7FB;
  height: 100vh;
  padding: 60px 0 0 0;
  text-align: center;
}

.subtitle {
  font-size: 15px;
  color: black;
  margin-left: 8px
}

.publishjob {
  font-size: 18px;
  color: black;
  margin-bottom: 20px;
  font-weight: bold
}

.notfindjob {
  color: black;
  font-size: 14px;
  margin-left: 5px;
  margin-right: 5px
}

.rightclick {
  color: #4095E5;
  font-size: 14px
}

.divider {
  width: 3px;
  background: #4095E5;
  height: 25px
}

.address {
  margin: 15px auto;
  display: flex;
  flex-direction: column;
  width: 60%
}

.bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px
}

.bottombtn {
  color: black;
  background: white;
  border: #EAECEE 1px solid;
  font-size: 14px;
  padding: 5px 25px;
  border-radius: 20px
}

</style>
